<template>
    <label class="block" :class="{ 'max-w-4xl': !fullWidth }">
        <span class="text-gray-700" :class="labelClass">{{ label }}</span>
        <select
            :disabled="disabled"
            class="block w-full border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1"
            :class="[noPadding ? '' : 'mt-1', disabled ? 'bg-gray-100 cursor-not-allowed' : null]"
            :name="name"
            @input="(e) => $emit('input', e.target.value)"
            :value="value"
        >
            <option :value="null" selected :disabled="!unsettable" v-if="placeholder">{{ placeholder }}</option>
            <option
                v-for="(option, index) in options"
                :key="index"
                :value="option.value"
            >
                <span v-if="debugStore.debugMode" class="font-mono">
                    [Value: {{ option.value }}]
                </span>
                {{ option.name }}
            </option>
        </select>
        <error :error="error" />
    </label>
</template>
<script>
import {useDebugStore} from "../../stores/debug";

export default {
    name: "Select",
    props: {
        unsettable: {
            default: false,
            type: Boolean
        },
        placeholder: String,
        name: String,
        label: String,
        noPadding: {
            type: Boolean,
            default: false
        },
        disabled:{
            type: Boolean,
            default: false
        },
        value: [String, Number],
        options: {
            type: Array,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
        labelClass: {
            type: String,
            required: false
        },
        fullWidth: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            debugStore: useDebugStore(),
        };
    },
};
</script>
